import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=0463a613&scoped=true&"
import script from "./VInput.vue?vue&type=script&lang=js&"
export * from "./VInput.vue?vue&type=script&lang=js&"
import style0 from "./VInput.vue?vue&type=style&index=0&id=0463a613&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463a613",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0463a613')) {
      api.createRecord('0463a613', component.options)
    } else {
      api.reload('0463a613', component.options)
    }
    module.hot.accept("./VInput.vue?vue&type=template&id=0463a613&scoped=true&", function () {
      api.rerender('0463a613', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VInput.vue"
export default component.exports